
import React, { useReducer } from "react";
import axios2 from 'services/axios2';

import {useParams} from "react-router-dom";
import {Link,hashHistory} from 'react-router-dom';
import { ToastContainer, toast } from 'react-toastify';

import FigureItem  from "components/FigureItem";

import { withRouterJim } from "router/withRouterJim";
import NuConfirm from "components/nubox/Box/NuConfirm";


import { NotificationContainer, NotificationManager } from 'react-notifications';
import {
  Table,
  Button,
  Container,
  Modal,
  ModalHeader,
  ModalBody,
  FormGroup,
  ModalFooter,
  ToastHeader,
} from "reactstrap";

const cbo=[
  {  value:'1', label: 'label1'},
]


const initialForm = {
  idd:0,
  ope:'n',
  
};

//$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$
class TablaAsistencia extends React.Component {
  state = {

    modalImagen: false,
    id_asisfe:0,
    fecha:'',
    form: Object.assign({}, initialForm),

    dataList: [],/* lista  */
    columnsA:[{num_col: 1, label: 'a1', id_asisfe: 145}],
    //{"col":1, "label":'A1', 'id_asisfe':145 }
    
  };
  //--------------------------------------
  constructor(props) {
    super(props);

    this.refNuConfirm = React.createRef();
  }
    

  //---------------------------------
  componentDidMount() {
    //--limpiamos el array de prueba
    this.setState({dataList:[]});
    

    this.cargar_data();

    const date = new Date();
    const defaultValue = date.toLocaleDateString('en-CA');

    let id_asisfe = this.props.params.id;
    console.log(id_asisfe);
    this.setState({ id_asisfe: id_asisfe, 
                    fecha: defaultValue });
    
  }
  //----------------especial, actualiza valores del form -------------------------------
  handleChangeForm = (e) => {
    //requerimos la prop name='?' en cada control
    
    //--- esto lo hacemos porque en vez de utilizar valores true, false
    //--- tenemos que utilizar 1, 0
    if(e.target.type==="checkbox"){

      let res = e.target.checked? 1:0;        
      this.setState({
        form:{
          ...this.state.form,
          [e.target.name]: res,
        }
      })
    }else{
      this.setState({
        form: {
          ...this.state.form,
          [e.target.name]: e.target.value,
        },
      });
    }
  };

  //-------------- cambiamos valor en la tabla
  handleCellChange=(index, columnId, value)=>{
    const newData = [...this.state.dataList];
    newData[index][columnId] = value;
    
    //console.log(newData);
    //setData({  data: newData    });
    this.setState({ datalist: newData });
  }
  //-------------------------------------------
  /*
    "id_mate": 20,
    "id_carre": 4,

   */
  cargar_data=()=>{
    console.log("cargar_data")
    //let id_est = this.props.store.user.id_est;
    let id_mate = this.props.store.materia.id_mate;
    let id_peri = this.props.store.user.id_peri;
    let periodo = this.props.store.user.periodo;
    

    let param = { 
      id_mate: id_mate,
      id_peri: id_peri,
    }

    console.log(param)
    axios2.post("tabla_asistencia_get_list", param)
    .then(res => {
        console.log(res.data)
        if(res.data.tabla.length>0){ 
            this.setState({dataList: res.data.tabla,
              columnsA: res.data.columnsA
            });
            //this.setState({columnsA: res.data.columnsA});
        }else{
          this.setState({dataList: [] });
          this.setState({columnsA: [] });
            //NotificationManager.error('No existen datos');
        }
    }).catch(error => {
        alert("---- Existio un error ---");
        console.log(error);
    });
  }
  //----------------------------------------
  //------------------------------------
  finalizar_click =(e)=>{
    e.preventDefault();

    this.refNuConfirm.current.show({
      message: 'Esta seguro de finalizar el llenado? \n Una vez finalizado, no se podra modificar.',
      title: 'Confirmar',
      icon: 'fa fa-question-circle',
      classHeader: 'bg-default1 ',
      classButton: 'btn btn-danger',
      accept: () => {
        console.log("confirmar finalizar")
        this.finalizar();
        //let idd = item.id_carre;
        //this.modalRef.current.eliminar(idd);
      },
      reject: () => {
          console.log('cancel');
      },
      acceptLabel: 'Aceptar',
      rejectLabel: 'Cancelar'
    })
  }
  //-----------------------------------
  //-----------------------------------
  finalizar=()=>{
    const user = this.props.store.user;
    const materia = this.props.store.materia;
    //console.log(this.state.dataList)
    
    let param = { 
      id_peri: user.id_peri,
      id_mate: materia.id_mate,
      id_doc: user.id_doc,
        
      //tabla:  JSON.stringify( this.tabla_filter() )
      
    };
    console.log(param);
    
    axios2.post("tabla_asistencia_finalizar", param)
    .then(res => {
        console.log(res.data);
        if(res.data.exito === 1){ 
            
            NotificationManager.success(res.data.men);         
        }else{
            NotificationManager.error(res.data.men);
            
        }

    }).catch(error => {
        alert("---- Existio un error ---");
        console.log(error);
        
    });

  }
  //-----------------------------------
  //-----------------------------------
  //-----------------------------------------
  // retorna id_mate, nombre, sigla
  guardar_click=()=>{
    console.log("guardar_click");
    console.log("")
    
    this.save();
  }
  //-----------------------------------
  tabla_filter=()=>{
    const filteredBooks = [];
    this.state.dataList.forEach(filterValue => {
      filteredBooks.push({"id_asis":filterValue.id_asis, "asis": filterValue.asis} );
    });
    return filteredBooks;
  }

  //-----------------------------------
  save =() =>{
    const user = this.props.store.user;
    const materia = this.props.store.materia;

    let param = { 
      id_asisfe: this.state.id_asisfe,
      tabla:  JSON.stringify( this.tabla_filter() )
    };

    console.log(param);
    
    axios2.post("asistencia2_store", param)
    .then(res => {
        console.log(res.data);
        if(res.data.exito === 1){ 
            
            NotificationManager.success(res.data.men);         
        }else{
            NotificationManager.error(res.data.men);
            
        }

    }).catch(error => {
        alert("---- Existio un error ---");
        console.log(error);
        
    });
    
  }
  //-------------------------------------
  //------------------------------
  render() {
    let materia = this.props.store.materia

    return(
      <div>
        {/* ---   --- */}
        { //JSON.stringify(this.state.form)
        }
        <div className="escritorio center-align p-3">

          <div className="row">
            <div className="col-md-7">
              <h3> Tabla Asistencias </h3>
              {/*<Button 
                  className="btn btn-success" 
                  onClick={ this.finalizar_click } >
                  GUARDAR PLANILLA
              </Button>*/}
              &nbsp;
              <Button 
                  className="btn btn-danger" 
                  onClick={ this.finalizar_click } >
                FINALIZAR 
              </Button>
              <p>
                Sigla: { materia.sigla }<br />
                Materia: { materia.nombre }  <br />
                Grupo: { materia.grupo } <br />
                Fecha: { this.state.fecha }<br/>
              </p>
            </div>

            <div className="col-md-5">
              <table className="grilla">
                <tbody><tr>
                  <td className="cell_plomo"><b>Presente</b></td>
                  <td>P</td>
                  <td className="recuadro" ><i className="fa fa-check" ></i></td>
                </tr>
                  <tr>
                    <td>Falta</td>
                    <td>F ó " "</td>
                    <td className="recuadro" ></td>
                  </tr>
                  <tr>
                    <td>Licencia</td>
                    <td>L</td>
                    <td className="recuadro" style={{ backgroundColor: '#00afed' }} >L</td>
                  </tr>
                  
                </tbody></table>
            </div>

          </div>

        <table className="tabla_azul  table-hover border_right">
          <thead>
            <tr>
                <th width="80px">Nro</th>
                <th >Nro. Doc.</th>
                <th >Nombre</th>
               
                {this.state.columnsA.map((it, index)=>(
                  <th key={ index +3 }>
                    {it.num_col}
                    <Link to={`/asistencia2/${it.id_asisfe}`} className=" btn-box-tool btn-sm" data-widget="collapse">
                      <i className="fa fa-pencil"></i>
                    </Link>
                  </th>
                ))}

                <th  >Asis.</th>
                <th  >Falt.</th>
                <th  >Lic.</th>
                <th  >%</th>
            </tr>
          </thead>
          <tbody>
              
              {this.state.dataList.map((item,index) => ( 
                  <tr key={index}>
                    <td>{ index+1 }</td>
                    <td>{ item.nro_doc }</td>
                    <td>{ item.nomape_tmp }</td>
                    
                    {this.state.columnsA.map((it, index)=>(
                      (() => {
                      switch(it.num_col){
                        case 1: return  <td>{item.a1}</td>
                        case 2: return <td>{item.a2}</td>
                        case 3: return <td>{item.a3}</td>
                        case 4: return <td>{item.a4}</td>
                        case 5: return <td>{item.a5}</td>
                        case 6: return <td>{item.a6}</td>
                        case 7: return <td>{item.a7}</td>
                        case 8: return <td>{item.a8}</td>
                        case 9: return <td>{item.a9}</td>
                        case 10: return <td>{item.a10}</td>
                        case 11: return <td>{item.a11}</td>
                        case 12: return <td>{item.a12}</td>
                        case 13: return <td>{item.a13}</td>
                        case 14: return <td>{item.a14}</td>
                        case 15: return <td>{item.a15}</td>
                        case 16: return <td>{item.a16}</td>
                        case 17: return <td>{item.a17}</td>
                        case 18: return <td>{item.a18}</td>
                        case 19: return <td>{item.a19}</td>
                        case 20: return <td>{item.a20}</td>
                        case 21: return <td>{item.a21}</td>
                        default: return <td>Err</td>
                      }   
                      })()
                    ))}
  
                    <td style={{ backgroundColor: '#fde9d9' }} >{ item.n_asis }</td>
                    <td style={{ backgroundColor: '#fabf8f' }}>{ item.n_faltas }</td>
                    <td style={{ backgroundColor: '#e6b8b7' }}>{ item.n_lic }</td>
                    <td>{ item.porcentaje }</td>
                  </tr>
              ))}
              
          </tbody>
        </table>
            
        
        </div>
        

        <NotificationContainer/>
        <NuConfirm   ref={ this.refNuConfirm }    />
      </div>
    )
  }
}

//------------para que soporte la funcionalidad de parametros
export default withRouterJim(TablaAsistencia);